import React, {useEffect, memo} from 'react';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import propertyWriter from '../../lib/urlWriters/webURL';
import styles from './Members.scss';
import {
  deleteProfileWatch
} from '../../actions';
import {propertyFormat} from '../../lib/propertyFormat';
import Loading from '../Loading/Loading';
import TrackedPropertyItem from './TrackedPropertyItem';
import Button from '@material-ui/core/Button';

const TrackedSuburbs = (props) => {
    
  const { trackedProperties, deleteProfileWatch } = props;
  let hasTrackedProperties = (trackedProperties && trackedProperties.subscribedProperties && trackedProperties.subscribedProperties.length > 0);

  return (trackedProperties.status === 'fetching' ? <Loading /> :
    <div className={`mt-5 mb-5 ${styles.TrackSuburbContainer}`}>
      <h3 className="mb-2">Tracked Properties</h3>
      <p className="mb-4">Get monthly updates on your favourite properties&apos; estimated value range, nearby properties{' '}
        recently sold or currently listed, as well as local market trends.</p>
      <div className={`mt-4 ${styles.trackSuburbList}`}>
        {hasTrackedProperties ?
          trackedProperties.subscribedProperties.map((property, index) => {

            const formattedProperty = propertyFormat(property.propertyDetails);

            return <TrackedPropertyItem
              key={index}
              index={index}
              trackedProperties={trackedProperties}
              property={property}
              formattedProperty={formattedProperty}
              deleteProfileWatch={deleteProfileWatch}
              pathname={propertyWriter(property.propertyDetails)}
            />;
          })
          :
          <div className={`rounded mb-4 ${styles.noSuburbDiv}`}>
            <img src="/assets/images/no-property-image.png"/>
            <div>
              <h3>Track your favourite Properties</h3>
              <p>Keep informed about your favourite properties with a monthly digest. Get started by searching for{' '}properties.</p>
              <Button
                className={styles.searchPropertiesButton}
                variant={'contained'}
                color={'primary'}
                onClick={(e) => props.history.push('/')}>
                    Search for Properties
              </Button>
            </div>
          </div>
        }
      </div>
    </div>
  );
  
};

TrackedSuburbs.propTypes = {
  deleteProfileWatch: PropTypes.func,
  trackedProperties: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    trackedProperties: state.profileWatch,
    userId: state.user.currentUser.uuid};
};
const mapDispatchToProps = {
  deleteProfileWatch,
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(TrackedSuburbs));